import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  brands: { data: [], raw: [], loading: false },
  backTypes: { data: [], raw: [], loading: false },
  filterTypes: { data: [], raw: [], loading: false },
  entityTypes: { data: [], raw: [], loading: false },
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
